"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setGlobalData = exports.default = void 0;
var globalDataContext = () => {
  var env, appName, appDomain, mmcomDomain;
};
var setGlobalData = props => {
  var appEnv = props.componentProps.env === null || typeof props.componentProps.env === 'undefined' ? 'dev' : props.componentProps.env;
  globalDataContext.env = appEnv;
  globalDataContext.appName = props.componentProps.appName;
  globalDataContext.appDomain = props.componentProps.appDomain;
  if (appEnv === 'prod') globalDataContext.mmcomDomain = 'https://www.massmutual.com';else if (appEnv === 'preview') globalDataContext.mmcomDomain = 'https://www2.massmutual.com';else if (appEnv === 'qa') globalDataContext.mmcomDomain = 'https://www-qa.massmutual.com';else globalDataContext.mmcomDomain = 'https://www-dev.massmutual.com';
};
exports.setGlobalData = setGlobalData;
var _default = exports.default = globalDataContext;